/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatchPatientAssignmentDto } from '../../models/patch-patient-assignment-dto';
import { ResponsePatientDto } from '../../models/response-patient-dto';

export interface PatientsControllerUpdateAssignment$Params {

/**
 * The tenant of the patient
 */
  tenant: string;

/**
 * The patient id
 */
  id: string;
      body: PatchPatientAssignmentDto
}

export function patientsControllerUpdateAssignment(http: HttpClient, rootUrl: string, params: PatientsControllerUpdateAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
  const rb = new RequestBuilder(rootUrl, patientsControllerUpdateAssignment.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePatientDto>;
    })
  );
}

patientsControllerUpdateAssignment.PATH = '/thalea-patients/patients/{tenant}/{id}/assignment';
